export default __webpack_public_path__ + "static/media/263.7bae8d1b.png";